import { styled } from '@linaria/react';

const Wrapper = styled.div`
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
`;

export default Wrapper;
